import { render, staticRenderFns } from "./proList.vue?vue&type=template&id=1546f42f&scoped=true&"
import script from "./proList.vue?vue&type=script&lang=js&"
export * from "./proList.vue?vue&type=script&lang=js&"
import style0 from "./proList.vue?vue&type=style&index=0&id=1546f42f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1546f42f",
  null
  
)

export default component.exports